/**
 * Canonical layout constants for canvas/react-flow node positioning.
 * Anything that places, sizes, or measures nodes/edges should import from here.
 */

// Visual node dimensions used by edge geometry (LoopLink, SplitConvergeLink, etc.)
// These match the legacy collapsed-node footprint, NOT the inline editor.
export const NODE_WIDTH = 250;
export const NODE_HEIGHT = 80;

// Dagre fallbacks used when a node hasn't been measured yet (e.g. first paint
// after AI generation, refreshCanvas, paste). Sized to InlineNodeView's
// rendered footprint (520 wide; height covers most expanded states) so layout
// produced before measurement is still close enough to avoid catastrophic
// overlap. Once nodes mount and React Flow v11 populates `node.width` /
// `node.height`, dagre uses those real dimensions and these fallbacks no
// longer apply. (v12 stores measurements under `node.measured.*` instead —
// update `hasLiveDims` in layoutUtils when upgrading.)
export const DAGRE_DEFAULT_NODE_WIDTH = 520;
export const DAGRE_DEFAULT_NODE_HEIGHT = 350;

// Extra height added to measured node height to prevent dagre overlap.
export const NODE_HEIGHT_PADDING = 20;

// Floor applied to every node's height before it goes into dagre. Stops
// collapsed nodes (~80px) from packing tight, then overlapping when the user
// expands them. Tuned to the typical expanded body of an InlineNodeView
// (description + instructions + chips). Loosens collapsed-only canvases
// slightly but eliminates expand-overlap entirely.
export const MIN_LAYOUT_NODE_HEIGHT = 350;

// Gap dagre adds AROUND each node. With rankdir='LR':
//   nodesep = vertical gap between nodes in the same rank
//   ranksep = horizontal gap between adjacent ranks
// Total center-to-center = (dim + sep). Tuned so 520-wide / 350-tall nodes
// have ~120px breathing room.
export const DAGRE_NODE_SEPARATION = 120;
export const DAGRE_RANK_SEPARATION = 120;

// Overlap-avoidance padding used by PositioningUtils spiral search.
export const VERTICAL_PADDING = 20;

// Fallback dimensions for components placed via overlap-avoidance search.
export const DEFAULT_COMPONENT_WIDTH = 280;
export const DEFAULT_COMPONENT_HEIGHT = 54;

// Y position of a component handle (input/output dot) relative to its top edge.
export const COMPONENT_HANDLE_POSITION = 16;

// Edge-rendering offsets.
export const EDGE_CONNECTOR_OFFSET = 8;
export const LOOP_PATH_HEIGHT_OFFSET = 120;
export const TRIGGER_LABEL_Y_OFFSET = 22;
